import { createJpegtranWorker, JpegtranWorkerApi } from './worker';

/**
 * jpegtran によるロスレス回転。
 *
 * Worker の生成は 823KB の vendor を読み込むため、初回呼び出し時に一度だけ行い使い回す。
 * (既存の ImageProcessorManager が Worker を static フィールドで保持しているのと同じ方針)
 */
let sharedWorker: JpegtranWorkerApi | null = null;

const getWorker = (): JpegtranWorkerApi => {
  if (!sharedWorker) {
    sharedWorker = createJpegtranWorker();
  }
  return sharedWorker;
};

/**
 * @param bytes 元の JPEG バイナリ
 * @param transformArgs 変換引数 (例: ['-rotate', '90'])
 * @returns 変換後の JPEG。ロスレスに変換できなかった場合は null
 */
export const rotateLossless = async (bytes: Uint8Array, transformArgs: string[]): Promise<Uint8Array | null> => (
  getWorker().rotateLossless(bytes, [
    ...transformArgs,
    /* メタデータを維持する。最終的には呼び出し側で元セグメントに差し替える */
    '-copy', 'all',
    /* 端の MCU を失う変換を拒否する。これが無いと端に帯状の破綻が出る */
    '-perfect',
  ])
);
